import { useRouter } from 'next/router';

export const useIsPageActive = (page: string): boolean => {
	const router = useRouter();

	return router.pathname === page;
};
